<template>
    <div>
        <DatePicker
            v-model="dates"
            :format-locale="ko"
            select-text="확인"
            cancel-text="취소"
            :enable-time-picker="false"
            range
            multi-calendars
            :clearable="false"
            :format="dateFormat"
            class="select_date"
            :auto-apply="true"
        >
            <template #input-icon>
                <img class="input-slot-image" src="@/assets/calendar-todo-fill.png" />
            </template>
        </DatePicker>
    </div>
</template>

<script lang="ts">
    import { DatePicker, globalStore, onMounted, ref, watch } from "@/BaseComponent";
    import { ko } from "date-fns/locale";

    export default {
        props: ["date"],
        emits: ["changeDate"],
        components: {
            DatePicker,
        },
        setup(props: any, emits: any) {
            const dates = ref<[Date, Date] | null>(null);
            const global = globalStore();
            onMounted(() => {
                if (global.searchDate.length === 0) {
                    const startDate = new Date(new Date().setDate(new Date().getDate() - 7));
                    const endDate = new Date();
                    dates.value = [startDate, endDate];
                } else {
                    dates.value = global.searchDate;
                }
            });

            watch(dates, (date: any) => {
                emits.emit("changeDate", date);
            });

            watch(props, () => {
                dates.value = props.date;
            });

            const dateFormat = (dates: any) => {
                let [startDate, endDate] = dates;
                let startYear = "" as string;
                let startDay = "" as string;
                let startMonth = "" as string;
                let endYear = "" as string;
                let endDay = "" as string;
                let endMonth = "" as string;
                if (startDate) {
                    startYear = startDate.getFullYear().toString().slice(2);
                    startDay = startDate.getDate().toString();
                    startMonth = (startDate.getMonth() + 1).toString();
                }
                if (endDate) {
                    endYear = endDate.getFullYear().toString().slice(2);
                    endDay = endDate.getDate().toString();
                    endMonth = (endDate.getMonth() + 1).toString();
                } else {
                    endDate = startDate;
                    endYear = endDate.getFullYear().toString().slice(2);
                    endDay = endDate.getDate().toString();
                    endMonth = (endDate.getMonth() + 1).toString();
                }

                return `${startYear}.${startMonth}.${startDay} - ${endYear}.${endMonth}.${endDay}`;
            };
            return {
                props,
                dateFormat,
                ko,
                dates,
            };
        },
    };
</script>
